import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import PersonSearchRegularAi from './person-search-regular-ai-icon.svg';

// @ts-expect-error
function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <PersonSearchRegularAi {...validProps} />;
}
SvgComponent.iconName = 'personSearchRegularAi';

export const PersonSearchRegularAiIcon = svgIconWrapper(SvgComponent);
